export default __webpack_public_path__ + "static/media/Group 11708.e12ecab3.svg";